import {
  TAuthConverter,
  TCreateConverter,
  TFetchConverter,
} from 'data/types/converter.types';
import {
  EUserListFilterParams,
  TAddNewUserDB,
  TAddNewUserUI,
  TAdminUserListDataDB,
  TAdminUserListDataUI,
  TDeleteUserDB,
  TDeleteUserUI,
  TPermissionsTypeDB,
  TPermissionsTypeUI,
  TUpdateUserDB,
  TUpdateUserUI,
  TUserDataDB,
  TUserDataUi,
  TUserIdentityDB,
  TUserIdentityUI,
  TUserListDataDB,
  TUserListDataUI,
} from 'data/types/user.types';
import { phoneNumberConverter } from './general.converters';
import { TTableFilters } from '../types/generic.types';

const permissionsConverter: TFetchConverter<
  TPermissionsTypeUI[],
  TPermissionsTypeDB[]
> = {
  fromDb: data => {
    const newPermissions: TPermissionsTypeUI[] = [...data, 'SECURITY_VIEW'];
    return newPermissions;
  },
};

export const getUserProfileConvertor: TAuthConverter<
  void,
  void,
  TUserDataUi,
  TUserDataDB
> = {
  toDb: () => {
    /* do nothing */
  },
  fromDb: data => ({
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    phone: data.phone,
    address: data.formattedAddress
      ? {
          formattedAddress: data.formattedAddress,
          placeId: '',
          country: '',
          state: '',
          city: '',
          streetNumber: '',
          street: '',
          zipCode: '',
          latitude: undefined,
          longitude: undefined,
        }
      : undefined,
    profilePicture: data.profilePicture,
    type: data.type,
    permissions: permissionsConverter.fromDb(data.permissions),
    userId: data.userId,
    enabledFeatures: data.enabledFeatures,
  }),
};

export const adminUserListGetConverter: TFetchConverter<
  TAdminUserListDataUI,
  TAdminUserListDataDB
> = {
  fromDb: data => ({
    createdDate: data.createdDate,
    adminId: data.userId,
    fullName: data.fullName,
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email,
    phone: phoneNumberConverter.fromDb(data.phone || ''),
    userProfileStatus: data.userProfileStatus,
    lastLoggedInDate: data.lastLoggedInDate,
  }),
};

export const userListFilterConverter = (
  filters: TTableFilters<EUserListFilterParams>['filters'],
) => {
  const filtersToDB = {
    ...(filters?.firstName && {
      [EUserListFilterParams.FIRSTNAME]: filters?.firstName,
    }),
    ...(filters?.lastName && {
      [EUserListFilterParams.LASTNAME]: filters?.lastName,
    }),
    ...(filters?.email && {
      [EUserListFilterParams.EMAIL]: filters?.email,
    }),
    ...(filters?.phone && {
      [EUserListFilterParams.MOBILE]: filters?.phone,
    }),
    ...(filters?.elcLeadStatus && {
      [EUserListFilterParams.ELC_LEAD_STATUS]: filters?.elcLeadStatus,
    }),
    ...(filters?.readyAdminStatus && {
      [EUserListFilterParams.READY_ADMIN_STATUS]: filters?.readyAdminStatus,
    }),
    ...(filters?.elcPMstatus && {
      [EUserListFilterParams.ELC_PM_STATUS]: filters?.elcPMstatus,
    }),
    ...(filters?.siteCoordinatorStatus && {
      [EUserListFilterParams.SITE_COORDINATOR_STATUS]:
        filters?.siteCoordinatorStatus,
    }),
    ...(filters?.cafeCoordinatorStatus && {
      [EUserListFilterParams.CAFE_COORDINATOR_STATUS]:
        filters?.cafeCoordinatorStatus,
    }),
  };
  return filtersToDB;
};

export const userListGetConverter: TFetchConverter<
  TUserListDataUI,
  TUserListDataDB
> = {
  fromDb: data => ({
    createdDate: data.createdDate,
    adminId: data.userId,
    fullName: data.fullName,
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email,
    phone: phoneNumberConverter.fromDb(data.phone || ''),
    userProfileStatus: data.userProfileStatus,
    lastLoggedInDate: data.lastLoggedInDate,
  }),
};

export const userIdentityGetConverter: TFetchConverter<
  TUserIdentityUI,
  TUserIdentityDB
> = {
  fromDb: data => ({
    email: data.email,
    id: data.id,
    fullName: data.fullName,
  }),
};

// export const addNewUserConverter: TCreateConverter<
//   TAddNewUserUI,
//   TAddNewUserDB
// > = {
//   toDb: data => ({
//     firstName: data.firstName,
//     lastName: data.lastName,
//     email: data.email,
//     phone: phoneNumberConverter.toDb(data.phone) || '',
//     profileType: data.profileType,
//   }),
// };

export const addNewUserConverter: TCreateConverter<
  TAddNewUserUI,
  TAddNewUserDB
> = {
  toDb: data => ({
    userId: data.userId,
    profileType: data.profileType,
  }),
};

export const deleteUserConverter: TCreateConverter<
  TDeleteUserUI,
  TDeleteUserDB
> = {
  toDb: data => ({
    userId: data.userId,
  }),
};

export const updateUserConverter: TCreateConverter<
  TUpdateUserUI,
  TUpdateUserDB
> = {
  toDb: data => ({
    userId: data.userId,
    firstName: data.firstName,
    lastName: data.lastName,
    phone: phoneNumberConverter.toDb(data.phone) || '',
  }),
};
